import AudioRecorder from './AudioRecorder'

export {
  AudioRecorder
}


// WEBPACK FOOTER //
// ./src/components/AudioRecorder/index.js